import { Col, Row } from "react-bootstrap";
import LeapHeaderComponent from "../../leap-components/LeapHeaderComponent";

const HeaderSubComponent = () => {
  return (
    <div>
      <Row className="mb-1">
        <Col className="col-md-12">
          <h1>Licence and Enforcement Access Portal</h1>
        </Col>
      </Row>
    </div>
  );
};

const Header = () => {
  return <LeapHeaderComponent headerContent={<HeaderSubComponent />} />;
};

export default Header;
